module.exports = __webpack_public_path__ + "img/P2-B6.d96dacf1.svg";